module.exports = __webpack_public_path__ + "img/caolv.932983e9.png";